function initializeGoogleAnalytics4(): void {
  const measurementId = ENV_CONSTANTS.GA4_MEASUREMENT_ID;
  if (!measurementId) return;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;

  const firstScript = document.getElementsByTagName('script')[0];
  firstScript.parentNode!.insertBefore(script, firstScript);

  window.dataLayer = window.dataLayer || [];

  function gtag(): void {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer!.push(arguments);
  }

  window.gtag = gtag;
  window.gtag('js', new Date());
  window.gtag('config', measurementId, { send_page_view: false });
}

initializeGoogleAnalytics4();

export {};
